import { toUserId } from '@streamr/utils';
import { Identity } from './Identity';
/**
 * KeyPairIdentity is an Identity that is defined by a public key and a private key.
 * It uses the public key as the UserID.
 */
export class KeyPairIdentity extends Identity {
    publicKeyString;
    publicKey;
    privateKey;
    constructor(publicKey, privateKey) {
        super();
        this.publicKey = publicKey;
        this.privateKey = privateKey;
        this.publicKeyString = toUserId(this.publicKey);
        this.assertValidKeyPair();
    }
    async getUserIdRaw() {
        return this.publicKey;
    }
    async getUserId() {
        return this.publicKeyString;
    }
    async getPrivateKey() {
        return this.privateKey;
    }
    // eslint-disable-next-line class-methods-use-this
    async getTransactionSigner(_rpcProviderSource) {
        throw new Error('This key pair can not sign transactions!');
    }
    /** @internal */
    static getKeyPairFromConfig(config) {
        const result = config.auth;
        if (!result.privateKey) {
            throw new Error('A privateKey was expected in the config, but none is defined!');
        }
        return result;
    }
}
